const booleanOptions = [
  {id: 'yes', translationKey: 'inputs.booleanOptions.yes'},
  {id: 'no', translationKey: 'inputs.booleanOptions.no'},
];

export default booleanOptions;
